export const TiktokReturn = {
  TIKTOK_SHOP_MANAGED: 'tiktok_shop_managed',
  SELLER_MANAGED: 'seller_managed',
};

export const tiktokReturnTypes = [
  { id: TiktokReturn.TIKTOK_SHOP_MANAGED, value: TiktokReturn.TIKTOK_SHOP_MANAGED, label: 'Tiktok shop managed' },
  { id: TiktokReturn.SELLER_MANAGED, value: TiktokReturn.SELLER_MANAGED, label: 'Seller managed' },
];
